
import React from 'react';
import { cn } from '@/lib/utils';

interface ButtonCircleProps {
  onClick: () => void;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  backgroundColor?: string;
  iconColor?: string;
  borderColor?: string;
  className?: string;
  'aria-label'?: string;
  disabled?: boolean;
}

const ButtonCircle = ({
  onClick,
  children,
  size = 'large',
  backgroundColor = 'bg-uplivion-blue',
  iconColor = 'text-white',
  borderColor,
  className,
  'aria-label': ariaLabel,
  disabled = false,
}: ButtonCircleProps) => {
  const sizeClasses = {
    small: 'w-10 h-10',
    medium: 'w-12 h-12',
    large: 'w-14 h-14',
  };

  const iconSizeClasses = {
    small: '[&_svg]:h-5 [&_svg]:w-5',
    medium: '[&_svg]:h-6 [&_svg]:w-6',
    large: '[&_svg]:h-7 [&_svg]:w-7',
  };

  const hoverClasses = backgroundColor.includes('uplivion-blue') 
    ? 'hover:bg-uplivion-blue/90' 
    : `hover:${backgroundColor}/90`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'rounded-full flex items-center justify-center shadow-lg transition-colors',
        sizeClasses[size],
        iconSizeClasses[size],
        backgroundColor,
        iconColor,
        borderColor,
        hoverClasses,
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className
      )}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export default ButtonCircle;
